import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4 6a5 5 0 0 1-4.9-4h9.8a5 5 0 0 1-4.9 4m6-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
      clipRule: "evenodd"
    }
  )
);
var SvgEmojiFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var EmojiFilled_default = SvgEmojiFilled;

export { EmojiFilled_default as default };
